import { gql } from "@apollo/client";

const GET_EVENTS = gql(`query Events {
  events {
    address {
      street
      city
      county
      venueName
      googleLocationLink
    }
    borderColor
    ticketImage
    maxCartTicketQuantity
    category {
      id
      name
      subcategories {
        id
        name
      }
    }
    company {
      approval
      avatar
      comission
      comissionHoldingFee
      id
    }
    description
    documents {
      id
      key
      status
      title
    }
    endDate
    fields
    id
    images
    isMainEvent
    isPublished
    name
    organizerDisplayName
    organizerEmail
    organizerPhone
    twilioPhone
    organizerWebsite
    promoCodes {
      id
      name
      percent
    }
    startDate
    entryType
    status
    subcategory {
      id
      name
    }
    subCategory {
      id
      name
    }
    tags {
      id
      name
    }
    ticketTypes {
      id
      ticketOrder
      isPublished
      order
      name
      description
      series
      total
      available
      price
      eventId
      categoryId
      category {
        id
        name
      }
      sellStartDate
      sellEndDate
    }
    visibility
    comission
    comissionHoldingFee
    currency
  }
}

`);

// todo solve all the references for this query
// todo re add documents and missing fields
const GET_EVENT_BY_ID = gql(`query Event($eventId: ID!) {
  event(id: $eventId) {
    address {
      city
      county
      googleLocationLink
      street
      venueName
      moduleStatus
    }
    tickets {
      borderColor
      ticketImage
      maxCartTicketQuantity
      comission
      promoCodes {
        id
        name
        percent
      }
      ticketTypes {
        available
        category {
          id
          name
        }
        ticketSubcategory {
          id
          name
        }
        categoryId
        ticketSubcategoryId
        description
        eventId
        id
        isPublished
        name
        order
        price
        sellEndDate
        sellStartDate
        series
        ticketOrder
        total
        promotionType
        promotionMetadata
        validFrom
        validUntil
      }
      seasonPasses {
        id
        excluded
        ticketType {
          id
          name
        }
      }
      ticketSubcategories {
        id
        name
      }
      entryType
      ditlReport
      moduleStatus
    }
  questionnaire {
    id
    moduleStatus
    pages {
      id
      title
      order
      questions {
        id 
        title 
        description 
        required 
        type 
        scope 
        order
        questionnairePageOrder
        visible
        options { 
          id 
          label 
          order 
          visibility 
          visibilityRules { 
            id 
            sourceQuestionId 
            allowedValues 
          } 
        }
        visibilityRules { 
          id 
          sourceQuestionId 
          allowedValues 
        }
      }
    } 
  }
    general {
      category {
        id
        name
      }
      description
      company {
        account {
          email
          id
          phone
        }
        avatar
        approval
        comission
        comissionHoldingFee
        firstName
        id
        lastName
        companyInfo {
          vatObligations
        }
      }
      openingHours
      endDate
      fields
      id
      images
      isPublished
      mainEventCountyVisibility
      name
      organizerDisplayName
      organizerEmail
      organizerPhone
      twilioPhone
      organizerWebsite
      startDate
      status
      subCategory {
        id
        name
      }
      locationVenue {
        id
        name
      }
      tags {
        id
        name
      }
      visibility
      countyVisibility
      isPermanent
      trendingBg
      seatsIoEventKey
      currency
      isRecurring
      isRecurringWithSeatingMaps
      isSeasonPassSale
      commissionPaidByUser
      linkedEvents {
        general {
          id
          name
          startDate
          endDate
        }
      }
      permanentVenueId
    }
    rating {
      bookLink
      priceRangeEnd
      priceRangeStart
      program
      rating
      reviewsCount
      moduleStatus
    }
    booking {
      areas {
        id
        name
        price
        description
        tables{
          id
          name
        }
      }
      pauses {
        id
        startDate
        endDate
        description
        area {
          id
          name
        }
      }
      automaticConfirmation
      enabledCustomerPlan
      enabledMenuPurchase
      enabledSpecialRequirements
      enabledHoldingFeePerPerson
      isBookableUnit
      maxGuests
      minGuests
      maxBookingGuests
      minBookingGuests
      bookingDuration
      bookingInterval
      holdingFee
      id
      openingHours
      tables {
        area {
          id
          name
        }
        capacity
        price
        description
        id
        name
      }
      moduleStatus
      moduleStatusBookingMenu
      comissionHoldingFee
      menus {
        id
        name
        description
        category
        price
        quantity
        quantityMetric
        vat
      }
      specialOccasions {
        id
        name
      }
      dietaryRestrictions {
        id
        name
      }
      tableRequirements {
        id
        name
      }
      clientTags {
        id
        name
      }
    }
  }
}`);

const GET_EVENT_LIST = gql`
  query Events {
    events {
      id
      name
      status
      images
      ticketTypes {
        price
      }
      currency
    }
  }
`;
const GET_SEASON_PASS_EVENTS = gql`
query SeasonPassEvents($ticketTypeId: ID!) {
  seasonPassEvents(ticketTypeId: $ticketTypeId) {
    id
    excluded
    event {
      general {
        id
        name
        startDate
        endDate
        images
        status
        subCategory {
          id
          name
        }
      }
      address {
        city
        venueName
      }
    }
  }
}
`
const GET_EVENT_LIST_EVENTMANAGER = gql`
  query General {
    events {
      general {
        category {
          id
          name
        }
        fields
        id
        images
        name
        isPublished
        startDate
        endDate
        status
        subCategory {
          id
          name
        }
      }
      address {
        city
        county
        googleLocationLink
        street
        venueName
      }
      ticketsSummary {
        total
        available
      }
    }
  }
`;
const GET_ALL_TAGS = gql`
  query Tags {
    tags {
      id
      name
    }
  }
`;

const GET_EVENT_FOR_INVITE = gql`
  query Event($eventId: ID!) {
    event(id: $eventId) {
      general {
        images
        name
        organizerDisplayName
        startDate
        endDate
        organizerEmail
      }
      address {
        venueName
      }
    }
  }
`;

const GET_EVENT = gql`
  query Event($eventId: ID!) {
    event(id: $eventId) {
      id
      images
      name
      description
      organizerEmail
      organizerPhone
      twilioPhone
      organizerWebsite
      isPublished
      fields
      currency
      ticketTypes {
        price
        id
        name
        available
        ticketOrder
        total
        isPublished
        series
        sellStartDate
        sellEndDate
        order
      }
    }
  }
`;

const GET_EVENT_DATA_FOR_TICKETS_TABLE = gql`
  query Event($eventId: ID!) {
    event(id: $eventId) {
      general {
        name
        currency
        isRecurring
        isSeasonPassSale
      }
    }
  }
`;

export const GET_EVENT_TICKET_TYPES_FOR_CASHIER = gql`
  query GetEventTicketTypesForCashier($eventId: ID!) {
    event(id: $eventId) {
      general {
        id
        isRecurring
      }
      tickets {
        ticketTypes {
          id
          name
          price
          available
          kind
          isPublished
        }
      }
    }
  }
`;

const GET_QUICK_EVENTS = gql`
  query EventsQuickSearch($statuses: [EventStatus!], $companyIds: [ID!]) {
    eventsQuickSearch(statuses: $statuses, companyIds: $companyIds) {
      totalCount
      items {
        id
        name
      }
    }
  }
`;

const GET_COUNTY_AVAILABILITY = gql`
query CountyAvailability {
  countyAvailability
}
`

const GET_COMPANY_PERMANENT_VENUES = gql`
query CompanyPermanentVenues {
  companyPermanentVenues {
    general {
      id
      name
    }
  }
}
`

export {
  GET_EVENT_LIST,
  GET_EVENTS,
  GET_EVENT_BY_ID,
  GET_ALL_TAGS,
  GET_EVENT_LIST_EVENTMANAGER,
  GET_EVENT,
  GET_EVENT_FOR_INVITE,
  GET_EVENT_DATA_FOR_TICKETS_TABLE,
  GET_QUICK_EVENTS,
  GET_COUNTY_AVAILABILITY,
  GET_SEASON_PASS_EVENTS,
  GET_COMPANY_PERMANENT_VENUES
};
